// extracted by mini-css-extract-plugin
export default {"container":"wns8YqljPpA4cFERkEEV","text":"KXASk0_yM45GUb6cvXsp","image":"AfDYT_0K1o2wZ5RclJqU","reverse":"L_R_mdalYjJRY2fGvcmw"};